/* eslint-disable consistent-return */
import { type RefObject, useState } from 'react';
import { type Options, useIntersectionEffect } from './useIntersectionEffect';

export default function useHiddenItemsObserver<T extends HTMLElement>(options: Options<T>) {
    const [count, set] = useState(0);

    useIntersectionEffect(
        (entries) => {
            set(entries.filter(({ isIntersecting }) => !isIntersecting).length);
        },
        options,
        [count]
    );

    return count;
}
